import { ApiResponse } from "@/utils/ApiResponse";
import { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import apiClient from "@/clients/apiClient";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";

export async function ListModeloVehiculoAction(
  paginacionFilterParams: PaginacionFilterParams
): Promise<ApiResponse<ModelosVehiculoInterface>> {
  const { data } = await apiClient.get<ModelosVehiculoInterface>(
    "/gvModeloVehiculos",
    {
      params: paginacionFilterParams,
    }
  );
  return {
    status: 200,
    data,
    message: "Modelo de vehiculos obtenidas correctamente",
  };
}
